import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { CREDIT, logoBawaan, logoUrl, teksVersi } from "@/lib/branding";

// G3-0: empty = API on the same domain ("/api", production behind Nginx)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// One request per page load; refreshed after an upload in Pengaturan.
let cache = null;
let listeners = [];

// G1-C: when the Owner replaced the logo, the install icons follow it.
function pasangManifest(d) {
  const link = document.getElementById("app-manifest");
  if (!link) return;
  link.href = d && Number.isInteger(d.putih)
    ? `${BACKEND_URL}/api/public/manifest.webmanifest?v=${d.putih}`
    : "/manifest.webmanifest";
}

export function muatUlangBranding() {
  cache = axios.get(`${BACKEND_URL}/api/public/branding`).then((r) => r.data).catch(() => null);
  cache.then((d) => {
    pasangManifest(d);
    listeners.forEach((fn) => fn(d));
  });
  return cache;
}

export function useBranding() {
  const [info, setInfo] = React.useState(null);
  React.useEffect(() => {
    let alive = true;
    const fn = (d) => alive && setInfo(d);
    listeners.push(fn);
    (cache || muatUlangBranding()).then(fn);
    return () => {
      alive = false;
      listeners = listeners.filter((x) => x !== fn);
    };
  }, []);
  return info;
}

// varian "putih" for dark backgrounds, "hitam" for white pages.
export const Logo = ({ varian = "putih", className = "h-8 w-auto", ...rest }) => {
  const info = useBranding();
  const src = logoUrl(info, varian, BACKEND_URL);
  return (
    <img
      src={src}
      alt="SOQPRINT"
      className={className}
      data-testid={`logo-${varian}`}
      onError={(e) => {
        const fallback = logoBawaan(varian);
        if (!e.currentTarget.src.endsWith(fallback)) e.currentTarget.src = fallback;
      }}
      {...rest}
    />
  );
};

// Login, sidebar footer, and (owner 2026-10-09) the public tracking and ACC pages.
// Small and muted but readable (11 px), centred, in the page flow (never covers buttons).
// `warna`: the text colour (light on the blue sidebar).
// owner 2026-10-17 (VERSI-APLIKASI): the readable version ("v2.17.3", owner 2026-10-23) under the credit;
// `tautan` (staff pages) makes it a link to the release notes, public pages show plain text.
const VERSI_NOMOR = process.env.REACT_APP_VERSI_NOMOR;
export const AppCredit = ({ className = "", warna = "text-slate-500", tautan = false }) => {
  const versi = teksVersi(VERSI_NOMOR);
  return (
    <div data-testid="app-credit" className={`text-[11px] leading-relaxed text-center ${warna} ${className}`}>
      {CREDIT.map((baris) => <p key={baris}>{baris}</p>)}
      {versi && (tautan
        ? <p><Link to="/catatan-pembaruan" data-testid="app-versi" className="underline-offset-2 hover:underline" title="Catatan pembaruan">{versi}</Link></p>
        : <p data-testid="app-versi">{versi}</p>)}
    </div>
  );
};
